import type { SVGProps } from 'react'
const SvgSyDone = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={8} fillOpacity={0.24} />
		<path d="M19.076 5.576 11.5 13.15l-2.576-2.574-.848.848 2.893 2.894a.76.76 0 0 0 1.062 0l7.893-7.894z" />
	</svg>
)
export default SvgSyDone
